(() => {
  if (window.__cardologyHomeCoreRequested) return;
  window.__cardologyHomeCoreRequested = true;

  const featuredMobileStyleId = 'cardology-featured-mobile-cart-style';
  if (!document.getElementById(featuredMobileStyleId)) {
    const style = document.createElement('style');
    style.id = featuredMobileStyleId;
    style.textContent = `
      [id^="HomeFeatured-"] .ch-product-card__quick-form {
        position: static !important;
        right: auto !important;
        bottom: auto !important;
        left: auto !important;
        z-index: auto !important;
        display: block !important;
        width: auto !important;
        margin: 12px 16px 0 !important;
        opacity: 1 !important;
        transform: none !important;
      }

      @media screen and (max-width: 767px) {
        [id^="HomeFeatured-"] .ch-product-card__quick-add {
          display: block !important;
          width: 100% !important;
          min-height: 44px;
          padding: 12px 16px;
          font-size: 13px;
          text-align: center;
          box-sizing: border-box;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const currentScript = document.currentScript;
  const currentSrc = currentScript?.src;
  if (!currentSrc) return;

  const coreUrl = new URL(currentSrc, window.location.href);
  coreUrl.pathname = coreUrl.pathname.replace(/cardology-home\.js$/, 'cardology-home-core.js');
  coreUrl.searchParams.set('cardology_core', '20260915-customizer-sync');

  const script = document.createElement('script');
  script.src = coreUrl.toString();
  script.defer = true;
  script.dataset.cardologyHomeCore = 'true';
  document.head.appendChild(script);
})();
